import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from '../../AuthContext';
import Logo from "../../assets/Img/Logo-1.png";
import UserImg from "../../assets/Img/User.gif";
import "../../App.css";

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export default function WorkerTaskApp() {
  const { user, logout } = useContext(AuthContext);
  const workerId = user?.EmployeeID || '';
  const workerName = user?.Name || '';
  const workerDept = user?.Department || '';
  
  const [hover, setHover] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const [activeTasks, setActiveTasks] = useState([]);
  const [availableLots, setAvailableLots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchLot, setSearchLot] = useState('');
  const [elapsedTimes, setElapsedTimes] = useState({});

  // Claim/Complete Modals state
  const [claimModalLot, setClaimModalLot] = useState(null);
  const [targetQty, setTargetQty] = useState('');
  
  const [completeModalTask, setCompleteModalTask] = useState(null);
  const [completedQty, setCompletedQty] = useState('');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (workerId && workerDept) {
      fetchData();
    }
  }, [workerId, workerDept]);

  useEffect(() => {
    let interval;
    if (activeTasks.length > 0) {
      interval = setInterval(() => {
        const now = new Date();
        const newElapsed = {};
        activeTasks.forEach(task => {
          const start = new Date(task.start_time);
          const diff = Math.floor((now - start) / 1000);
          const hrs = String(Math.floor(diff / 3600)).padStart(2, '0');
          const mins = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
          const secs = String(diff % 60).padStart(2, '0');
          newElapsed[task.log_id] = `${hrs}:${mins}:${secs}`;
        });
        setElapsedTimes(newElapsed);
      }, 1000);
    } else {
        setElapsedTimes({});
    }
    return () => clearInterval(interval);
  }, [activeTasks]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [tasksRes, lotsRes] = await Promise.all([
        axios.get(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/active/${workerId}`),
        axios.get(`${BASE_URL}/api/wip-dashboard/worker/available-lots/${workerDept}`)
      ]);
      
      if (tasksRes.data.success && tasksRes.data.hasActive) {
        setActiveTasks(tasksRes.data.tasks);
      } else {
        setActiveTasks([]);
      }

      if (lotsRes.data.success) {
        setAvailableLots(lotsRes.data.lots);
      }
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Failed to fetch data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const startTask = async () => {
    const claimAmt = parseInt(targetQty);
    if (!claimAmt || claimAmt <= 0) return Swal.fire('Error', 'Invalid qty', 'error');
    if (claimAmt > claimModalLot.availableQty) return Swal.fire('Error', `Max available is ${claimModalLot.availableQty}`, 'error');

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/claim`, {
        worker_id: workerId,
        worker_name: workerName,
        lot_id: claimModalLot.lot_id,
        confirm_time_new_id: claimModalLot.confirmTimeNewId,
        claimed_qty: claimAmt
      });
      if (res.data.success) {
        Swal.fire('Started!', 'Task has started.', 'success');
        setClaimModalLot(null);
        setTargetQty('');
        fetchData();
      }
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to start task', 'error');
    } finally {
      setLoading(false);
    }
  };

  const completeTask = async () => {
    if (!completedQty) return Swal.fire('Validation Error', 'Enter completed quantity.', 'warning');
    
    if (parseInt(completedQty) > completeModalTask.claimed_qty) {
      return Swal.fire('Error', `Aapne sirf ${completeModalTask.claimed_qty} pcs claim kiye the. Isse zyada complete nahi kar sakte!`, 'error');
    }

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/wip-dashboard/worker/lot-qty/complete`, {
        log_id: completeModalTask.log_id,
        completed_qty: parseInt(completedQty)
      });
      if (res.data.success) {
        Swal.fire('Completed!', res.data.message, 'success');
        setCompleteModalTask(null);
        setCompletedQty('');
        fetchData();
      }
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to complete task', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!workerId) {
    window.location.href = "/";
    return null;
  }

  const filteredLots = availableLots.filter(lot => lot.lot_id.toLowerCase().includes(searchLot.toLowerCase()));

  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg bg-body-white" style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.2)", background: "white" }}>
        <div className="container-fluid">
          <a className="navbar-brand" href="/User-dashboard">
            <img src={Logo} className="img-fluid rounded-top" alt="Logo" style={{ height: "40px", marginLeft: "10px" }} />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a className="nav-link active" href="/User-dashboard" style={{ color: "inherit", fontWeight: "600" }}><i className="bi bi-house-door me-1"></i> HOME</a>
              </li>
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a className="nav-link active" href="/User-Tickets" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} style={{ color: hover ? "#ff0000" : "inherit", fontWeight: "600" }}><i className="bi bi-ticket-detailed me-1"></i> TICKET</a>
              </li>
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a className="nav-link active" href="/wip-worker-app" style={{ color: "#0ea5e9", fontWeight: "700" }}><i className="bi bi-stopwatch me-1"></i> TASK TRACKER</a>
              </li>
            </ul>
            <div className="d-flex align-items-center ms-lg-auto mt-3 mt-lg-0">
              <span className="me-3" style={{ fontWeight: 600, color: "#475569" }}>
                Welcome, {workerName}!
              </span>
              <div className="dropdown">
                <a className="d-flex align-items-center text-decoration-none dropdown-toggle" role="button" data-bs-toggle="dropdown" style={{ cursor: "pointer" }}>
                  <img src={UserImg} alt="Profile" className="rounded-circle shadow-sm" style={{ width: "40px", height: "40px", objectFit: "cover", border: "2px solid #e2e8f0" }} />
                </a>
                <ul className="dropdown-menu dropdown-menu-end shadow-sm" style={{ border: "none", borderRadius: "12px", marginTop: "10px" }}>
                  <li>
                    <a className="dropdown-item text-danger fw-bold d-flex align-items-center" style={{ cursor: "pointer", padding: "10px 20px" }} onClick={logout}>
                      <i className="bi bi-box-arrow-right me-2"></i> Logout
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className="container mt-4">
        {loading && <div className="text-center py-4"><i className="bi bi-hourglass-split spin fs-2 text-primary"></i></div>}

        {/* ACTIVE TASKS SECTION */}
        {activeTasks.length > 0 && (
          <div className="mb-5">
            <h4 style={{ fontWeight: 800, color: "#0f172a", marginBottom: "16px" }}><i className="bi bi-activity text-primary me-2"></i> Active Tasks</h4>
            <div className="row g-3">
              {activeTasks.map(task => (
                <div key={task.log_id} className="col-12 col-md-6 col-lg-4">
                  <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 10px 25px rgba(0,0,0,0.05)", border: "1px solid #e2e8f0" }}>
                    <div style={{ background: "linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%)", padding: "20px", textAlign: "center", color: "white" }}>
                      <div style={{ fontSize: "32px", fontWeight: 800, fontFamily: "monospace", letterSpacing: "-1px" }}>
                        {elapsedTimes[task.log_id] || '00:00:00'}
                      </div>
                      <div style={{ fontSize: "12px", opacity: 0.8, textTransform: "uppercase", letterSpacing: "1px" }}>Elapsed Time</div>
                    </div>
                    <div style={{ padding: "20px" }}>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted fw-bold">Lot ID</span>
                        <span className="fw-bolder">{task.lot_id}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted fw-bold">Supervisor</span>
                        <span className="fw-bolder">{task.supervisor || '-'}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-3">
                        <span className="text-muted fw-bold">Claimed Qty</span>
                        <span className="fw-bolder badge bg-light text-dark fs-6">{task.claimed_qty} pcs</span>
                      </div>
                      <button 
                        onClick={() => { setCompleteModalTask(task); setCompletedQty(''); }}
                        className="btn btn-success w-100 fw-bold shadow-sm"
                        style={{ borderRadius: "12px" }}
                      >
                        <i className="bi bi-check-circle-fill me-2"></i> FINISH WORK
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* AVAILABLE LOTS SECTION */}
        <div style={{ background: "white", padding: "24px", borderRadius: "20px", boxShadow: "0 10px 30px rgba(0,0,0,0.03)", border: "1px solid #f1f5f9" }}>
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            <h4 style={{ fontWeight: 800, color: "#0f172a", margin: 0 }}><i className="bi bi-list-task text-primary me-2"></i> Available Lots ({workerDept})</h4>
            <div style={{ position: "relative", width: isMobile ? "100%" : "300px" }}>
              <i className="bi bi-search" style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }}></i>
              <input 
                type="text" 
                placeholder="Search Lot ID..." 
                value={searchLot}
                onChange={e => setSearchLot(e.target.value)}
                style={{ width: "100%", padding: "10px 16px 10px 40px", borderRadius: "12px", border: "1px solid #cbd5e1", outline: "none" }}
              />
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-hover align-middle mobile-table">
              <thead className="table-light">
                <tr>
                  <th className="py-3 text-secondary text-uppercase" style={{ fontSize: "13px" }}>Lot ID</th>
                  <th className="py-3 text-secondary text-uppercase" style={{ fontSize: "13px" }}>Total Qty</th>
                  <th className="py-3 text-secondary text-uppercase" style={{ fontSize: "13px" }}>Available Qty</th>
                  <th className="py-3 text-secondary text-uppercase" style={{ fontSize: "13px" }}>Claimed By</th>
                  <th className="py-3 text-secondary text-uppercase text-end" style={{ fontSize: "13px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredLots.length === 0 ? (
                  <tr><td colSpan="5" className="text-center py-4 text-muted">No pending lots available for your department.</td></tr>
                ) : (
                  filteredLots.map(lot => (
                    <tr key={lot.confirmTimeNewId}>
                      <td className="fw-bold" data-label="Lot ID">{lot.lot_id}</td>
                      <td data-label="Total Qty">{lot.TotalQty}</td>
                      <td data-label="Available Qty"><span className="badge bg-success bg-opacity-10 text-success fs-6 border border-success border-opacity-25">{lot.availableQty}</span></td>
                      <td data-label="Claimed By">
                        {lot.active_workers && lot.active_workers.length > 0 ? (
                          <div className="d-flex flex-wrap gap-1">
                            {lot.active_workers.map((w, idx) => (
                              <span key={idx} className="badge bg-secondary" style={{ fontSize: "11px" }}>
                                {w.worker_name} ({w.claimed_qty})
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-muted small">-</span>
                        )}
                      </td>
                      <td className="text-end" data-label="Action">
                        <button 
                          className="btn btn-primary btn-sm fw-bold px-4 py-2 w-100 mobile-w-auto" 
                          style={{ borderRadius: "8px" }}
                          onClick={() => { setClaimModalLot(lot); setTargetQty(''); }}
                        >
                          Start <i className="bi bi-play-fill ms-1"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* CLAIM MODAL */}
      {claimModalLot && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
          <div style={{ background: "white", padding: "32px", borderRadius: "24px", width: "100%", maxWidth: "420px", animation: "slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1)", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}>
            <div className="d-flex align-items-center mb-3">
              <div style={{ width: "48px", height: "48px", borderRadius: "12px", background: "#e0f2fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#0ea5e9", fontSize: "24px", marginRight: "16px" }}>
                <i className="bi bi-play-circle-fill"></i>
              </div>
              <div>
                <h4 style={{ fontWeight: 800, color: "#0f172a", margin: 0, letterSpacing: "-0.5px" }}>Start Task</h4>
                <p className="text-muted mb-0" style={{ fontSize: "14px", fontWeight: 500 }}>Lot: {claimModalLot.lot_id}</p>
              </div>
            </div>
            
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "16px", padding: "16px", marginBottom: "24px" }}>
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted" style={{ fontWeight: 600, fontSize: "13px" }}>AVAILABLE QUANTITY</span>
                <span className="badge bg-success bg-opacity-10 text-success fs-6 px-3 py-2 border border-success border-opacity-25 rounded-pill">{claimModalLot.availableQty} pcs</span>
              </div>
            </div>
            
            <label style={{ fontWeight: 700, color: "#334155", marginBottom: "8px", display: "block" }}>Target Quantity <span className="text-danger">*</span></label>
            <div className="input-group mb-4">
              <span className="input-group-text" style={{ background: "#f1f5f9", border: "2px solid #e2e8f0", borderRight: "none", color: "#94a3b8" }}>
                <i className="bi bi-boxes"></i>
              </span>
              <input 
                type="number" 
                className="form-control" 
                value={targetQty}
                onChange={e => setTargetQty(e.target.value)}
                placeholder="How many pieces will you work on?"
                style={{ padding: "12px 16px", border: "2px solid #e2e8f0", borderLeft: "none", fontWeight: 600, color: "#0f172a", boxShadow: "none" }}
              />
            </div>
            
            <div className="d-flex gap-3">
              <button 
                className="btn btn-light flex-grow-1 border-0" 
                onClick={() => setClaimModalLot(null)}
                style={{ background: "#f1f5f9", color: "#64748b", fontWeight: 700, padding: "14px", borderRadius: "12px" }}
              >
                Cancel
              </button>
              <button 
                className="btn btn-primary flex-grow-1 border-0 shadow-sm" 
                disabled={!targetQty || loading} 
                onClick={startTask}
                style={{ background: "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)", fontWeight: 700, padding: "14px", borderRadius: "12px" }}
              >
                {loading ? <i className="bi bi-hourglass-split spin"></i> : 'START WORK'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* COMPLETE MODAL */}
      {completeModalTask && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
          <div style={{ background: "white", padding: "32px", borderRadius: "24px", width: "100%", maxWidth: "420px", animation: "slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1)", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}>
            <div className="d-flex align-items-center mb-3">
              <div style={{ width: "48px", height: "48px", borderRadius: "12px", background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center", color: "#16a34a", fontSize: "24px", marginRight: "16px" }}>
                <i className="bi bi-check-circle-fill"></i>
              </div>
              <div>
                <h4 style={{ fontWeight: 800, color: "#0f172a", margin: 0, letterSpacing: "-0.5px" }}>Finish Task</h4>
                <p className="text-muted mb-0" style={{ fontSize: "14px", fontWeight: 500 }}>Lot: {completeModalTask.lot_id}</p>
              </div>
            </div>
            
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "16px", padding: "16px", marginBottom: "24px" }}>
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted" style={{ fontWeight: 600, fontSize: "13px" }}>CLAIMED QUANTITY</span>
                <span className="badge bg-primary bg-opacity-10 text-primary fs-6 px-3 py-2 border border-primary border-opacity-25 rounded-pill">{completeModalTask.claimed_qty} pcs</span>
              </div>
            </div>
            
            <label style={{ fontWeight: 700, color: "#334155", marginBottom: "8px", display: "block" }}>Completed Quantity <span className="text-danger">*</span></label>
            <div className="input-group mb-4">
              <span className="input-group-text" style={{ background: "#f1f5f9", border: "2px solid #e2e8f0", borderRight: "none", color: "#94a3b8" }}>
                <i className="bi bi-box-seam"></i>
              </span>
              <input 
                type="number" 
                className="form-control" 
                value={completedQty}
                onChange={e => setCompletedQty(e.target.value)}
                placeholder="How many pieces did you finish?"
                max={completeModalTask.claimed_qty}
                style={{ padding: "12px 16px", border: "2px solid #e2e8f0", borderLeft: "none", fontWeight: 600, color: "#0f172a", boxShadow: "none" }}
              />
            </div>
            
            <div className="d-flex gap-3">
              <button 
                className="btn btn-light flex-grow-1 border-0" 
                onClick={() => setCompleteModalTask(null)}
                style={{ background: "#f1f5f9", color: "#64748b", fontWeight: 700, padding: "14px", borderRadius: "12px" }}
              >
                Cancel
              </button>
              <button 
                className="btn btn-success flex-grow-1 border-0 shadow-sm" 
                disabled={!completedQty || loading} 
                onClick={completeTask}
                style={{ background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)", fontWeight: 700, padding: "14px", borderRadius: "12px" }}
              >
                {loading ? <i className="bi bi-hourglass-split spin"></i> : 'SUBMIT'}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); scale: 0.95; }
          to { opacity: 1; transform: translateY(0); scale: 1; }
        }
        .form-control:focus {
          border-color: #3b82f6 !important;
          box-shadow: none !important;
        }
        .input-group-text {
          transition: all 0.2s ease-in-out;
        }
        .form-control:focus + .input-group-text,
        .input-group:focus-within .input-group-text {
          border-color: #3b82f6 !important;
          color: #3b82f6 !important;
        }
        @media (max-width: 768px) {
          .mobile-table thead {
            display: none;
          }
          .mobile-table tbody tr {
            display: block;
            margin-bottom: 16px;
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
            padding: 16px;
            border: 1px solid #e2e8f0;
          }
          .mobile-table tbody td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #e2e8f0;
            text-align: right;
          }
          .mobile-table tbody td:last-child {
            border-bottom: none;
            justify-content: center;
            padding-top: 16px;
          }
          .mobile-table tbody td::before {
            content: attr(data-label);
            font-weight: 700;
            font-size: 13px;
            color: #64748b;
            text-transform: uppercase;
            text-align: left;
            margin-right: 20px;
          }
          .mobile-w-auto {
            width: 100% !important;
          }
        }
        @media (min-width: 769px) {
          .mobile-w-auto {
            width: auto !important;
          }
        }
      `}</style>
    </div>
  );
}
